module.exports = __webpack_public_path__ + "static/media/person.3c424b8b.svg";